import { render } from "./DataPage.vue?vue&type=template&id=05673307"
import script from "./DataPage.vue?vue&type=script&lang=js"
export * from "./DataPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__